import Braze from "./Braze";

(() => {
    const POPUP_ID = "ic-welcome-popup";
    const BOUND_FLAG = "data-braze-bound";
    const SUBMIT_KEY = "ic-welcome-popup-submitted";
    const DISMISS_KEY = "ic-welcome-popup-dismissed";
    const CONFIRM_KEY = "ic-welcome-popup-confirm";

    // Mirrors footer.js: only the customer_posted redirect counts as a signup
    try {
        const succeeded = location.href.indexOf("customer_posted=") > -1;
        if (succeeded && sessionStorage.getItem(SUBMIT_KEY) === "1") {
            Braze.logOnlineSignup({ source: "popup" });
            sessionStorage.removeItem(SUBMIT_KEY);
            sessionStorage.setItem(CONFIRM_KEY, "1");
        }
        if (succeeded) sessionStorage.setItem(DISMISS_KEY, "1");
        // The flag only needs to survive the submit and its return navigation. Clear it on
        // every other load (bar the reCAPTCHA challenge) so a failed submit can't make a
        // later footer signup log a second online_signup.
        if (location.pathname !== "/challenge") sessionStorage.removeItem(SUBMIT_KEY);
    } catch {
        /* sessionStorage unavailable */
    }

    const bindForm = (form: HTMLFormElement) => {
        if (form.getAttribute(BOUND_FLAG) === "true") return;
        form.setAttribute(BOUND_FLAG, "true");
        form.addEventListener("submit", () => {
            if (form.checkValidity()) {
                // Flag the submit; the signup is logged on the post-submit success page.
                try {
                    sessionStorage.setItem(SUBMIT_KEY, "1");
                } catch {
                    /* storage blocked */
                }
            }
        }, true);
    };

    const tryBind = () => {
        const popup = document.getElementById(POPUP_ID);
        if (!popup) return false;
        const form = popup.querySelector("form");
        if (!form) return false;
        bindForm(form as HTMLFormElement);
        return true;
    };

    if (tryBind()) return;

    const observer = new MutationObserver(() => {
        if (tryBind()) observer.disconnect();
    });

    const root = document.body || document.documentElement;
    if (root) observer.observe(root, { childList: true, subtree: true });
    // The section is server-rendered, so once the page has loaded it is either bound
    // or disabled. Stop watching rather than observing every mutation for the page's life.
    window.addEventListener("load", () => observer.disconnect(), { once: true });
})();
